import { useState } from "react";

function SortArray(arrData, key) {
  const [isAsscending, setIsAsscending] = useState(true);
  for (let i = arrData?.length; i > 0; i--) {
    for (let j = 0; j < i; j++) {
      for (let k = 0; k < arrData?.[j]?.[key]?.length; k++) {
        let a = arrData?.[j]?.[key]?.charCodeAt(k);
        let b = arrData?.[j + 1]?.[key]?.charCodeAt(k);
        let temp = null;

        if (a > b && a - b !== 32) {
          temp = arrData?.[j];
          arrData[j] = arrData?.[j + 1];
          arrData[j + 1] = temp;
          break;
        } else if (a < b && a - b !== 32) {
          break;
        }
      }
    }
  }

  return {
    arrData: isAsscending ? arrData : arrData.reverse(),
    setIsAsscending: (value) => setIsAsscending(value),
  };
}

export default SortArray;
